// TODO migrate from react-router-redux, upgrade react-router

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export default history;
